var SliderDataTestIdEnum = /* @__PURE__ */ ((SliderDataTestIdEnum2) => {
  SliderDataTestIdEnum2["SLIDER_ROOT"] = "slider-root";
  SliderDataTestIdEnum2["SLIDER_TRACK"] = "slider-track";
  SliderDataTestIdEnum2["SLIDER_RANGE"] = "slider-range";
  SliderDataTestIdEnum2["SLIDER_THUMB"] = "slider-thumb";
  SliderDataTestIdEnum2["SLIDER_TOOLTIP"] = "slider-tooltip";
  return SliderDataTestIdEnum2;
})(SliderDataTestIdEnum || {});
export {
  SliderDataTestIdEnum
};
